import Form from 'react-bootstrap/Form';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MDBFile } from 'mdb-react-ui-kit';
import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axiosinterce from '../function/axiosInterceptor';
const EditBanner = () => {
    const urlredirect = useNavigate();
    const { sno } = useParams();
    const [menulist, setMenu] = useState([]);
    const [pagedata, setPagedata] = useState([{ page: "", Heading: "", Content: "", status: "" }])
    const getvalue = (e) => setPagedata({ ...pagedata, [e.currentTarget.name]: e.currentTarget.value });
    const fatchBanner = async () => {
        try {
            const response = await axiosinterce.get(`/admin/editbanner-view?sno=${sno}`)
            if (response.status === 1) { setPagedata(response.data); }
        } catch (err) {

        }
    }
    
    const fatchMenus = async () => {
        try {
            const response = await axiosinterce.get(`/admin/menu-list`)
            if (response.status === 1) { setMenu(response.data);; }
        } catch (err) {}

    }
    useEffect(() => { fatchBanner(); fatchMenus() }, [])
    const updateBaner = async (b) => {
        b.preventDefault();
        if (!b.currentTarget.title.value) {
            toast.warn('Please select page title...', { autoClose: 700, position: 'top-center' })
        }
        var img = b.currentTarget.image.files;
        const formData = new FormData();
        formData.append('image', img[0]);
        formData.append('sno', sno);
        formData.append('title', pagedata.page);
        formData.append('heading', pagedata.Heading);
        formData.append('content', pagedata.Content);
        formData.append('status', pagedata.status);
        const response = await axiosinterce.post(`/admin/update-banner`, formData)
        if (response.status === 1) {
            toast.success(response.message, { autoClose: 700, position: 'top-center' })
            urlredirect('/admin/banner');
        } else {
            toast.warn(response.message, { autoClose: 700, position: 'top-center' })
        }
    }
    return (<>
        <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <div className='d-flex justify-content-between'>
                            <div className=''>
                                <h6 className="card-title"> Edit banner</h6>
                                <p className="text-muted mb-3"><Link to="/admin/banner">Banner</Link> /<code>Edit banner</code></p>
                            </div>
                            <div>
                                <Link to="/admin/banner"><button className='custom-btn'> Banner List</button></Link>
                            </div>
                        </div>
                        <div className="table-responsive pt-3">
                            <Form onSubmit={updateBaner}>
                                <Form.Group className="mb-3" controlId="img">
                                    <MDBFile label='Image' id='image' />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="status">
                                    <Form.Label htmlFor="title">Page Title *</Form.Label>
                                    <select id="title" name="page" className='form-control' value={pagedata.page} onChange={getvalue}>
                                        <option>Select Page</option>
                                        {
                                            menulist.map((menu) => {
                                                return (<option>{menu.name}</option>)
                                            })
                                        }
                                    </select>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="Headding">
                                    <Form.Label>Headding</Form.Label>
                                    <Form.Control type="text" value={pagedata.Heading} placeholder="Headding" id="head" name="Heading" onInput={getvalue} />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="Content">
                                    <Form.Label id="contsrs">Content</Form.Label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={pagedata.Content}
                                        id={'conent'}
                                        onChange={(event, editor) => {
                                            setPagedata({ ...pagedata, 'Content': editor.getData() });
                                        }}
                                    />
                                    <Form.Group className="mb-3" controlId="status">
                                        <Form.Label htmlFor="status">Status</Form.Label>
                                        <Form.Select id="status" name="status" onChange={getvalue}>
                                            <option value="0" selected={pagedata.status === 0 ? true : false}>Inactive</option>
                                            <option value="1" selected={pagedata.status === 1 ? true : false}>Active</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mt-3" controlId="description">
                                        <input type="submit" className="btn btn-success" value='Save Details' />
                                    </Form.Group>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default EditBanner;